import { apiSlice } from "../../app/api/apiSlice";

export const registerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    registerTenant: builder.mutation({
      query: (data) => ({
        url: "/register/tenant",
        method: "POST",
        body: { ...data },
      }),
    }),
    checkTenantMail: builder.query({
      query: (mail) =>
        `/register/tenant/check-mail?mail=${encodeURIComponent(mail)}`,
    }),
  }),
});

export const { useRegisterTenantMutation, useLazyCheckTenantMailQuery } =
  registerApiSlice;
